
const mockResponse = {}


const mockDataRetriever = (setRawData, setLoading) =>{
    const second = 1000;
    const mockDelay = 5 * second;
    setLoading(true);
    const handle = setTimeout(() => {
        setRawData({...mockResponse});
        setLoading(false);
    }, mockDelay);
}

const userDataRetriever = (setRawData, setLoading) => {
    // raise not implemented error
    throw new Error("User data retriever not implemented");
}

const emptyDataRetriever = (setRawData, setLoading) => {
    setRawData({});
    setLoading(false);
};

export const variantDataRetrieverMapCreateEditDialog = {
    defValue: mockDataRetriever,
    userList: userDataRetriever,
    customerUser: emptyDataRetriever,
};